var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 8.33334C26.1506 8.33334 27.0834 9.26608 27.0834 10.4167V22.9167H39.5834C40.734 22.9167 41.6667 23.8494 41.6667 25C41.6667 26.1506 40.734 27.0833 39.5834 27.0833H27.0834V39.5833C27.0834 40.7339 26.1506 41.6667 25 41.6667C23.8494 41.6667 22.9167 40.7339 22.9167 39.5833V27.0833H10.4167C9.26611 27.0833 8.33337 26.1506 8.33337 25C8.33337 23.8494 9.26611 22.9167 10.4167 22.9167H22.9167V10.4167C22.9167 9.26608 23.8494 8.33334 25 8.33334Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 8.33334C26.1506 8.33334 27.0834 9.26608 27.0834 10.4167V22.9167H39.5834C40.734 22.9167 41.6667 23.8494 41.6667 25C41.6667 26.1506 40.734 27.0833 39.5834 27.0833H27.0834V39.5833C27.0834 40.7339 26.1506 41.6667 25 41.6667C23.8494 41.6667 22.9167 40.7339 22.9167 39.5833V27.0833H10.4167C9.26611 27.0833 8.33337 26.1506 8.33337 25C8.33337 23.8494 9.26611 22.9167 10.4167 22.9167H22.9167V10.4167C22.9167 9.26608 23.8494 8.33334 25 8.33334Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5bd65baf617c9ae17e0702c54f839b40.svg";
export { ForwardRef as ReactComponent };